
export const AUTH0_DOMAIN: string = process.env.REACT_APP_AUTH0_DOMAIN!
export const AUTH0_CLIENT_ID: string = process.env.REACT_APP_AUTH0_CLIENT_ID!
export const AUTH0_CLIENT_SECRET: string = process.env.REACT_APP_AUTH0_CLIENT_SECRET!
export const AUTH0_AUDIENCE: string = process.env.REACT_APP_AUTH0_AUDIENCE!
export const AUTH0_SCOPES: string = process.env.REACT_APP_AUTH0_SCOPES!
export const API_URL: string = process.env.REACT_APP_API_URL!